import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.553 3.418a.27.27 0 00-.382 0L7.3 6.29a.27.27 0 000 .382l.82.82a.27.27 0 00.382 0l.537-.537a1.07 1.07 0 011.514 0L12.2 8.6l1.577-1.576a.27.27 0 000-.382l-3.224-3.225zm-.948-.565a1.07 1.07 0 011.513 0l3.225 3.224a1.07 1.07 0 010 1.513L12.2 9.733 9.987 7.52a.27.27 0 00-.382 0l-.537.537a1.07 1.07 0 01-1.514 0l-.82-.82a1.07 1.07 0 010-1.514l2.871-2.87z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91 2.824a1.07 1.07 0 011.513 0L8.028 4.43l-.565.565L5.857 3.39a.27.27 0 00-.381 0L2.18 6.685a.27.27 0 000 .382l5.587 5.586a.27.27 0 00.381 0l3.486-3.486.566.566-3.486 3.486a1.07 1.07 0 01-1.513 0L1.615 7.633a1.07 1.07 0 010-1.514L4.91 2.824z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.407 9.202a.4.4 0 01.566 0l.813.814-.566.565-.813-.813a.4.4 0 010-.566zM6.897 9.52a.4.4 0 01.566 0l1.909 1.91-.566.566-1.91-1.91a.4.4 0 010-.565z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;